/**
 * PCO identifier display helpers — the single source of truth for how a
 * stored PCO number renders. Lives in `shared` so the API (xlsx cell
 * renderers, filename builder) and the web app render identical strings.
 */

/**
 * Display-pad a stored PCO number to Joey's PCO Log convention: 3-digit
 * left-padded when purely numeric ("4" → "004", "20" → "020"). Mixed
 * alphanumeric ("4A") renders verbatim — zero-padding a letter prefix
 * ("04A") doesn't match Joey's mental model. Empty / null / undefined
 * returns an empty string (callers that need a filename-safe fallback
 * apply their own, e.g. `padPcoNumber(x) || '000'`).
 */
export function padPcoNumber(n: string | null | undefined): string {
  const trimmed = (n ?? '').trim();
  if (trimmed === '') return '';
  return /^\d+$/.test(trimmed) ? trimmed.padStart(3, '0') : trimmed;
}
